import type { LatestOversightAssessmentRiskAssessmentResultsByRiskIdResponse } from '@risksmart-app/trpc/src/types';
import type { GetLatestOversightAssessmentRiskAssessmentResultsByRiskIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetLatestOversightAssessmentRiskAssessmentResultsByRiskIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetLatestOversightAssessmentRiskAssessmentResultsByRiskIdArgs = {
  riskId: string;
};

export const useGetLatestOversightAssessmentRiskAssessmentResultsByRiskId =
  createQueryHook<
    UseGetLatestOversightAssessmentRiskAssessmentResultsByRiskIdArgs,
    LatestOversightAssessmentRiskAssessmentResultsByRiskIdResponse,
    GetLatestOversightAssessmentRiskAssessmentResultsByRiskIdQuery
  >({
    trpcQueryOptions: (trpc, { riskId }) =>
      trpc.frontend.assessment.latestOversightAssessmentRiskAssessmentResultsByRiskId.queryOptions(
        {
          riskId,
        }
      ),
    mapTrpcDataToGraphQL: (data) =>
      data as unknown as GetLatestOversightAssessmentRiskAssessmentResultsByRiskIdQuery,
    graphqlDocument:
      GetLatestOversightAssessmentRiskAssessmentResultsByRiskIdDocument,
    graphqlVariables: ({ riskId }) => ({ RiskId: riskId }),
  });
